import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';

import FormikSelect from 'src/components/formik/FormikSelect';
import useGetRequest from 'src/hooks/useGetRequest';

import { useFormikContext } from 'formik';
import { getUserOptions } from '../../rolesConfig';

const AssignRolesRenderer = ({
  workflowId,
  widget
}: any) => {
  const formik = useFormikContext();

  const { result: roles, isLoading: rolesLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/roles/`,
    initialResult: [],
  });
  const { result: contacts, isLoading: contactsLoading } = useGetRequest({
    url: '/automatic/contacts/',
    initialResult: [],
  });

  if (rolesLoading || contactsLoading) return null;

  // todo - get rid of tostring stuff once we go to uuids
  const _roles = roles.filter((role: any) => ((widget.data.roleIds || []).map((roleId: any) => roleId.toString()) || []).includes(role.id.toString()));

  return (
    <Box>
      <Typography variant="h5">
        Assign roles
      </Typography>
      <Box pt={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Role
              </TableCell>
              <TableCell>
                User
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              _roles.map((role: any, index: any) => (
                <TableRow>
                  <TableCell>{role.name}</TableCell>
                  <TableCell>
                    <FormikSelect
                      fullWidth
                      name={`roleAssignments[${index}].accountId`}
                      options={getUserOptions(contacts)}
                      afterChange={() => formik.setFieldValue(`roleAssignments[${index}].roleId`, role.id)}
                    />
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default AssignRolesRenderer;
